<template>
    <PageBaseLayout class="rewards-view-override">
        <template #main>
          <main>
            <section class="_banner">      
              <img src="@/assets/imgs/rewards/star.svg">
              <h4>Rewards</h4>    
              <img src="@/assets/imgs/rewards/star.svg">
            </section>

            <section>
              <div class="_hero">
                <div>
                  <img src="@/assets/imgs/rewards/decor-left.svg">
                  <div>
                    <h6>THE BIGGEST <br>GIVEAWAY OF</h6>
                    <h4 class="secondary">2025</h4>
                  </div>
                  <img src="@/assets/imgs/rewards/decor-right.svg">
                </div>
              </div>

              <div class="_content">
                <div class="_part0">
                  <div>
                    <span class="_dot">•</span>
                    <p class="title">You’re not just attending. You’re playing.</p>
                    <span class="_dot">•</span>
                  </div>
                </div>

                <div class="_part1">
                    <div>
                      <img src="@/assets/imgs/rewards/decor-2-left.svg">
                      <p class="title large">How does it work?</p>
                      <img src="@/assets/imgs/rewards/decor-2-right.svg">
                    </div>
                    <br>
                    <p>There are 4 missions. Each one unlocks rewards, whitelist perks, or legendary prizes.</p>
                    <p>You can do one. You can do all. Just follow the steps. Bring the PROOF. <br><i>PROOF = <b>Tweet + Hashtags + Discord drop</b></i></p>
                </div>

                <div class="_part2">
                  <div class="_container">
                    <p class="title large">For the NFC Summit Attendees</p>
                    <div>
                      <div class="_sub-container">
                        <div data-i0>
                          <p class="title">The Autograph Hunt</p>
                          <p class="label large">Network like it’s 1999. Win like it’s onchain.</p>
                        </div>
                        
                        <div data-i1>
                          <div class="_image" data-reward0></div>
                          <p class="title small secondary"><b>Enter to win a trip to <br>a destination of your choice.</b></p>
                        </div>

                        <div data-i2>
                          <ul>
                            <li><p class="small">Network with people and ask for their autograph.</p></li>
                            <li><p class="small">Fill all 14 autograph boxes on your bag.</p></li>
                            <li><p class="small">Take a photo and post your PROOF.</p></li>          
                          </ul>
                          <BaseButton url="https://twitter.com/intent/tweet?text=I'm%20on%20the%20hunt%20for%20autographs%20at%20%40NFCSummit%20with%20%40alphalabs_xyz%20!%20Collected%20all%2014%20signatures%20hoping%20to%20win%20a%20dream%20trip.%20%F0%9F%A4%98%20%23Alphaglyph">
                            Use X Post Template 
                            <i class="icon middle site-x"></i>
                          </BaseButton>                          
                        </div>

                        

                      </div>

                      <!-- -- -->

                      <div class="_sub-container">
                        <div data-i0>
                          <p class="title">I’m an Alpha G.O.A.T</p>
                          <p class="label large">Flex your face. Earn your place.</p>
                        </div>

                        <div data-i1>
                          <div class="_image" data-reward1></div>
                          <p class="title small secondary"><b>50 will win Alpha G.O.A.T NFTs. <br>Best caption wins an Apple Watch.</b></p>
                        </div>

                        <div data-i2>
                          <ul>
                            <li><p class="small">Find the “I’m an Alpha G.O.A.T” banner.</p></li>
                            <li><p class="small">Step on the mark. Snap a photo.</p></li>
                            <li><p class="small">Scan the QR to auto-generate your post.</p></li>
                            <li><p class="small">Post your PROOF.</p></li>          
                          </ul>
                          <BaseButton url="https://twitter.com/intent/tweet?text=Look%20Dad!%20I'm%20an%20Alpha%20G.O.A.T%20%E2%98%BA%EF%B8%8F%20%40alphalabs_xyz%20%23ImAnAlphaGoat">
                            Use X Post Template 
                            <i class="icon middle site-x"></i>
                          </BaseButton>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div class="_part3">
                  <div class="_container">
                    <p class="title large">For All the Users</p>
                    <div>
                      <div class="_sub-container">
                        <div data-i0>
                          <p class="title">Contributors’ Challenge</p>
                          <p class="label large">Learn the protocol. Join the mission.</p>
                        </div>

                        <div data-i1>
                          <div class="_image" data-reward2></div>
                          <p class="title small secondary"><b>You’ll be whitelisted for risk-free rounds. <br>Win or get refunded. No downside.</b></p>
                        </div>

                        <div data-i2>
                          <ul>
                            <li><p class="small">Jump into our Telegram Mini App.</p></li>
                            <li><p class="small">Explore the Alpha G.O.A.Ts.</p></li>
                            <li><p class="small">Play with the G.E.M Protocol.</p></li>          
                            <li><p class="small">Complete the survey.</p></li>          
                          </ul>
                          <BaseButton title="Complete the Survey" pageId="MorePerks00"></BaseButton>
                        </div>

                      </div>

                      <!-- -- -->

                      <div class="_sub-container">
                        <div data-i0>
                          <p class="title">Honorary Autograph</p>
                          <p class="label large">One tweet. One question. One big win.</p>
                        </div>

                        <div data-i1>
                          <div class="_image" data-reward3></div>
                          <p class="title small secondary"><b>Winner gets an AirPods Max</b></p>
                        </div>

                        <div data-i2>
                          <ul>
                            <li><p class="small">Tweet your answer to: <br><b>“If you could get an honorary autograph from any living person, who would it be?”</b></p></li>
                            <li><p class="small">Post your PROOF.</p></li>
                          </ul>
                          <BaseButton url="https://twitter.com/intent/tweet?text=If%20I%20could%20get%20an%20honorary%20autograph%20from%20any%20living%20person%2C%20it%20would%20be%20...%20!%20Joining%20%40alphalabs_xyz%20's%20%23HonoraryAutograph%20contest%20%F0%9F%98%87">
                            Use X Post Template 
                            <i class="icon middle site-x"></i>
                          </BaseButton>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div class="_part4">
                  <div class="_circle">
                    <img src="@/assets/imgs/rewards/star.svg">
                  </div>
                </div>

                <div class="_part5">
                  <div class="_part-content _container-bg">
                    <div data-i0>
                      <img src="@/assets/imgs/rewards/decor-3-left.svg">
                      <h6 class="secondary">REMEMBER</h6>
                      <img src="@/assets/imgs/rewards/decor-3-right.svg">
                    </div>

                    <div data-i1>
                      <ul>
                        <li><span class="secondary">Post your PROOF =</span> Caption  <span class="secondary">+</span>  Post w/ hashtags  <span class="secondary">+</span>  Share your CODE and post link in a <span class="secondary">Discord Ticket</span></li>
                        <li>Your Personal Code will be handed out to you in an envelope at the NFC Summit 2025 venue entrance. <span class="secondary">This is non-custodial. If you lose it, it’s lost.</span> No backups. No support tickets. No second chances. No replacements.</li>
                        <li>Valid hashtags to choose from = <span class="secondary">#</span>AlphaLabs &nbsp;&nbsp;<span class="secondary">#</span>AlphaGoat &nbsp;&nbsp;<span class="secondary">#</span>Alphaglyph &nbsp;&nbsp;<span class="secondary">#</span>GemProtocol</li>
                        <li>All winners will be chosen at the Alpha G.O.A.Ts launch event and will be contacted via social media.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

            </section>
          </main>

        </template>

    </PageBaseLayout>

</template>

<style scoped lang="scss">

@use '@/assets/css/_tools' as tools;

$color-ported-secondary: #FF87CF;
$color-ported-outline-variant: var(--color-secondary);

$color-ported-primary-container: var(--color-secondary-dark);
$color-ported-on-primary-container: var(--color-secondary-light);
$color-ported-surf-container: var(--color-secondary);
$color-ported-surf-container-low: var(--color-bg);
$color-ported-on-surface-var: var(--color-secondary-variant);
$color-ported-outline: var(--color-secondary-light);

$color-surface: var(--color-surface);
$color-card-bg: var(--color-card-bg);

main {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 24px;
  gap: 24px;
}

section {
  width: 100%;
  max-width: 1158px;
  border-radius: 24px;
}

p + p {
  margin-top: 1em;
}

p + p.large {
  margin-top: 0;
}

.rewards-view-override {
  --bottom-pad: 0;
}

.secondary {
  color: $color-ported-secondary;
}

._banner {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  min-height: 176px;
  color: white;
  background-color: #101B52;
  background-image: radial-gradient(33.81% 89.49% at 50% 50%, #101B52 42.39%, rgba(0, 7, 67, 0) 100%), url('@/assets/imgs/rewards/banner-bg.svg');
  background-position: center;
}

._hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 48px;
  
  min-height: 226px;
  padding-bottom: 16px;

  text-align: center;

  border: 1px solid $color-ported-outline-variant;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border-bottom: none;  

  overflow: hidden;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    & > div {
      min-width: min(55%, 164px);
    }
  }
}

._content {
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: $color-ported-primary-container;

  gap: 56px;

  padding-bottom: 64px;
  
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  
  & > div {
    width: 100%;
  }
  
  ._container {   
    border-radius: 24px;
    padding: 8px;    
    
    text-align: center;

    border: solid 1px $color-ported-on-primary-container;

    & > p.title {
      margin-top: 16px;
      margin-bottom: 8px + 16px;
    }

    & > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 16px;
    }
  }

  ._sub-container {
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    overflow: hidden;
    flex: 1;

    & > div {      
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 8px;
      
      background-color: $color-ported-surf-container-low;
      
      &[data-i0] {
        gap: 4px;

        background-color: $color-ported-surf-container;
        border-bottom: solid 1.5px $color-ported-outline;
        
        p.label {
          color: $color-ported-on-surface-var;
        }
      }
      
      &[data-i1] {        
        justify-content: center;
        border-bottom: dotted 2px $color-ported-outline;
        min-height: 220px;
      }
      
      &[data-i2] {
        flex: 1;
        padding: 16px;        
        justify-content: space-between;
        min-height: 200px;
        gap: 16px;

        ul {
          padding-left: 1.5em;
        }
      }
    }

    ul {
      text-align: left;
      padding-inline: 1em;    

      b {
        color: $color-ported-on-surface-var;
      }
    }

    ul, button {
      width: 100%;
      max-width: 336px;
    }

    ._image {
      width: 100%;
      max-width: 406px;
      min-height: 82px;
      aspect-ratio: 406 / 171;

      background-size: auto 100%;
      background-position: center;
      background-repeat: no-repeat;
      
      margin-bottom: 8px;

      &[data-reward0] { @include tools.responsive-bg-x3('@/assets/imgs/rewards/trip.png'); }
      &[data-reward1] { @include tools.responsive-bg-x3('@/assets/imgs/rewards/watch.png'); }
      &[data-reward2] { @include tools.responsive-bg-x3('@/assets/imgs/rewards/risk-free.png'); }
      &[data-reward3] { @include tools.responsive-bg-x3('@/assets/imgs/rewards/headphones.png'); }
    }
  }

  ._part0 {
    display: flex;
    align-items: center;
    justify-content: center;
  
    border: solid 2px $color-ported-on-primary-container;
    border-left: none;
    border-right: none;
  
    margin-bottom: 24px;
    height: 8px;
  
    & > div {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      text-align: center;
      padding-left: 8px;
      padding-right: 8px;
      
      margin-left: 16px;
      margin-right: 16px;
      width: 100%;
      min-height: 64px;
      max-width: 688px;
    
      background-color: $color-surface;
      border-radius: 1000px;
    
      color: $color-ported-primary-container;
  
      ._dot {
        font-size: 1.5em;
      }
    }
  
  }
  
  ._part1 {
    max-width: 727px;    
    padding-inline: 16px;

    text-align: center;
    
    & > div {
      display: flex;
      align-items: center;
      justify-content: center;  
      gap: 16px;
    }
  }

  ._part2, ._part3 {
    max-width: 956px;
    padding-left: 16px;
    padding-right: 16px;
  }

  ._part4 {
    display: flex;
    align-items: center;
    justify-content: center;
  
    border: solid 2px $color-ported-outline;
    border-left: none;
    border-right: none;

    height: 8px;

    ._circle {
      display: flex;
      align-items: center;
      justify-content: center;
      
      border-radius: 50%;
      height: 40px;
      width: 40px;
      color: $color-ported-outline;
      background-color: $color-ported-surf-container-low;
      border: solid 2px $color-ported-outline;

      img {
        width: 18px;
        height: 18px;
      }
    }
  }

  ._part5 {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 16px;
    padding-right: 16px;
    max-width: 956px;

    ._part-content {
      width: 100%;
      border: solid 1.5px $color-ported-outline-variant;
      border-radius: 24px;
      overflow: hidden;        
  
      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
      }
  
      & > div[data-i0] {
        gap: 16px;
        text-align: center;
        background-color: $color-card-bg;
        border-bottom: solid 1.5px $color-ported-outline-variant;
      }
  
      & > div[data-i1] {
        text-align: left;
        padding: 24px;
      }
  
      ul {
        padding-left: 1em;
        line-height: 1.5;
      }

      li + li {
        margin-block-start: .75em;
      }
    }
  }
}

</style>